<template>
  <div>
    <MainPage
      v-if="loaded"
      :key="'chathub_' + activePage.slug"
      class="half-chat"
      :ratio="1"
      :half-chat="true"
      :hideTimeline="true"
    >
      <div class="chat-hubs" v-if="inactiveChatHubs">
        <div class="chat-hubs__header">
          <div class="chat-hubs__title">Chat Hubs</div>
          <a class="chat-hubs__rules" @click="rulesDialog = true">
            View Chat Rules
          </a>
        </div>

        <a
          class="chat-hubs__item"
          v-for="(item, index) in inactiveChatHubs"
          :key="index"
          @click="clickChatHub(item.slug)"
          :style="{ backgroundColor: item.chat_hub_color }"
        >
          <div class="chat-hubs__item-text">
            {{ item.heading_text }}: {{ item.intro_text }}
          </div>
          <v-btn icon color="white" class="chat-arrow">
            <v-icon size="51">$chat_arrow</v-icon>
          </v-btn>
        </a>
      </div>
    </MainPage>

    <v-dialog max-width="400" v-model="rulesDialog">
      <v-card>
        <v-card-text class="pa-6">
          <v-btn class="close" @click="rulesDialog = false" icon>
            <v-icon>$close</v-icon>
          </v-btn>
          <h2>Chat rules</h2>
          <br />
          <p>
            Welcome to the chat. This chat room will be open during video
            release periods to share reactions with others.
          </p>
          <p>
            This chat is a safe space for all attendees. Please see the rules of
            engagement below:
          </p>
          <ul>
            <li>
              Do not post personal contact information in the chat room (email,
              address, social, etc)
            </li>
            <li>Do not post links in the chat room</li>
            <li>
              Engaging in disturbing or inappropriate behavior will result in
              immediate removal from the chat room. (No warning required)
            </li>
            <li>
              Please respect the chat moderators. (Identified by * next to their
              names).
            </li>
          </ul>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import MainPage from "./main.page";

export default {
  name: "ChatHubPage",
  components: { MainPage },
  metaInfo: {
    titleTemplate: "%s - Chat Hubs",
  },
  data() {
    return {
      loaded: false,
      rulesDialog: false,
      chatHub: null,
      chat: null,
      articleSection: null,
    };
  },
  mounted() {
    this.setChatHub();
  },
  methods: {
    setChatHub() {
      this.setPageContext(this.$route.params.slug || "chat-hub", () => {
        this.loaded = true;
      });
    },
    clickChatHub(slug) {
      this.$router.push("/" + slug);
      this.setChatHub();
    },
  },
  computed: {
    activeChatHub() {
      return this.pages.find((c) => c.slug === this.activePage.slug);
    },
    inactiveChatHubs() {
      return this.pages.filter(
        (c) => c.is_chat_hub && c.slug !== this.activePage.slug
      );
    },
  },
};
</script>

<style scoped lang="scss">
</style>
